exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".staff {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n  margin-bottom: 60px;\n}\n.staff .image-staff {\n  width: 206px;\n  height: 206px;\n  border-radius: 100%;\n  background-position: center center;\n  background-size: cover;\n  background-repeat: no-repeat;\n  -ms-flex-order: 1;\n      order: 1;\n}\n.staff .infos-staff {\n  -ms-flex-order: 2;\n      order: 2;\n}\n.staff .infos-staff h2 {\n  color: #5c5c5c;\n  font-family: Dosis;\n  font-size: 25px;\n  font-weight: 700;\n}\n.staff .infos-staff h4 {\n  color: #5c5c5c;\n  font-family: Dosis;\n  font-size: 17px;\n  font-weight: 600;\n  margin-bottom: 0;\n}\n.staff .infos-staff p {\n  white-space: pre-line;\n  margin: 0;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/henriquezanini/Sites/Cães e Gatos/site/src/app/clinical-staff/clinical-staff.component.less
// module id = ../../../../../src/app/clinical-staff/clinical-staff.component.less
// module chunks = main